import { render, staticRenderFns } from "./DispatchModelAndProduct.vue?vue&type=template&id=75b88968&scoped=true"
import script from "./DispatchModelAndProduct.vue?vue&type=script&lang=js"
export * from "./DispatchModelAndProduct.vue?vue&type=script&lang=js"
import style0 from "./DispatchModelAndProduct.vue?vue&type=style&index=0&id=75b88968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b88968",
  null
  
)

export default component.exports